(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) document.documentElement.classList.add('inbody-design-mode');

  function initAnnouncements(scope) {
    var bars = (scope || document).querySelectorAll('[data-inbody-announcement]');
    bars.forEach(function (bar) {
      if (bar.dataset.initialized === 'true') return;
      bar.dataset.initialized = 'true';
      var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-announcement-slide]'));
      if (!slides.length) return;
      var index = 0;
      var timer;
      var delay = Math.max(3, parseInt(bar.dataset.speed || '5', 10)) * 1000;
      function show(next) {
        slides[index].classList.remove('is-active');
        index = (next + slides.length) % slides.length;
        slides[index].classList.add('is-active');
      }
      function restart() {
        window.clearInterval(timer);
        if (slides.length > 1 && bar.dataset.autoplay === 'true') {
          timer = window.setInterval(function () { show(index + 1); }, delay);
        }
      }
      var prev = bar.querySelector('[data-announcement-prev]');
      var next = bar.querySelector('[data-announcement-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); restart(); });
      if (next) next.addEventListener('click', function () { show(index + 1); restart(); });
      restart();
    });
  }

  function initAnnouncementOffset() {
    var bar = document.querySelector('[data-inbody-announcement]');
    if (!bar || bar.dataset.offsetInitialized === 'true') {
      if (!bar) document.documentElement.style.setProperty('--inbody-announcement-offset', '0px');
      return;
    }
    bar.dataset.offsetInitialized = 'true';
    var ticking = false;
    function updateOffset() {
      var remaining = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--inbody-announcement-offset', remaining + 'px');
      ticking = false;
    }
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateOffset);
    }
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    updateOffset();
  }

  function initStickyCart() {
    var sticky = document.querySelector('[data-inbody-sticky-cart]');
    if (!sticky) return;
    var mainButton = document.querySelector('.product_form .add_to_cart');
    var mainForm = document.querySelector('.product_form');
    var stickyButton = sticky.querySelector('[data-sticky-add]');
    var variantText = sticky.querySelector('[data-sticky-variant]');
    var priceText = sticky.querySelector('[data-sticky-price]');
    var compareText = sticky.querySelector('[data-sticky-compare]');
    var stickyImage = sticky.querySelector('[data-sticky-image]');
    var variantsNode = sticky.querySelector('[data-sticky-variants]');
    var variants = [];
    try { variants = variantsNode ? JSON.parse(variantsNode.textContent) : []; } catch (error) { variants = []; }
    var quantityText = sticky.querySelector('[data-sticky-quantity]');
    var quantityMinus = sticky.querySelector('[data-sticky-quantity-minus]');
    var quantityPlus = sticky.querySelector('[data-sticky-quantity-plus]');
    if (!mainButton || !stickyButton || !mainForm) return;

    function update() {
      var select = mainForm.querySelector('select[name="id"]');
      var idInput = mainForm.querySelector('input[name="id"]');
      var checked = mainForm.querySelector('.swatch input:checked');
      var label = '';
      if (select && select.options.length) label = select.options[select.selectedIndex].text;
      else if (checked) label = checked.value;
      if (variantText) variantText.textContent = label && label !== 'Default Title' ? label : '';
      var currentPrice = document.querySelector('.product_section .current_price, .product_section .money');
      var selectedId = select ? select.value : (idInput ? idInput.value : '');
      var selectedVariant = variants.find(function (variant) { return String(variant.id) === String(selectedId); });
      function formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, sticky.dataset.moneyFormat);
        return currentPrice ? currentPrice.textContent.trim() : '';
      }
      if (selectedVariant) {
        if (priceText) {
          priceText.textContent = formatMoney(selectedVariant.price);
          priceText.classList.toggle('is-sale', selectedVariant.compare_at_price > selectedVariant.price);
        }
        if (compareText) {
          var onSale = selectedVariant.compare_at_price > selectedVariant.price;
          compareText.hidden = !onSale;
          if (onSale) compareText.textContent = formatMoney(selectedVariant.compare_at_price);
        }
        if (stickyImage && selectedVariant.featured_image && selectedVariant.featured_image.src) {
          stickyImage.src = selectedVariant.featured_image.src;
          stickyImage.alt = selectedVariant.featured_image.alt || label || stickyImage.alt;
        }
      } else if (priceText && currentPrice) {
        priceText.textContent = currentPrice.textContent.trim();
      }
      stickyButton.disabled = mainButton.disabled || mainButton.closest('.disabled') !== null;
      var mainLabel = mainButton.querySelector('span');
      if (mainLabel) stickyButton.textContent = mainLabel.textContent.trim();
    }
    function setQuantity(next) {
      var quantity = Math.max(1, Math.min(99, next));
      var input = mainForm.querySelector('input[name="quantity"]');
      if (input) input.value = quantity;
      if (quantityText) quantityText.textContent = quantity;
    }
    if (quantityMinus) quantityMinus.addEventListener('click', function () { setQuantity(parseInt(quantityText.textContent, 10) - 1); });
    if (quantityPlus) quantityPlus.addEventListener('click', function () { setQuantity(parseInt(quantityText.textContent, 10) + 1); });
    stickyButton.addEventListener('click', function () {
      if (!stickyButton.disabled) {
        setQuantity(parseInt(quantityText ? quantityText.textContent : '1', 10));
        mainButton.click();
      }
    });
    mainForm.addEventListener('change', function () { window.setTimeout(update, 40); });
    var observer = new MutationObserver(update);
    observer.observe(mainButton, { attributes: true, subtree: true, childList: true });

    var visibilityTicking = false;
    function updateVisibility() {
      sticky.classList.toggle('is-visible', mainButton.getBoundingClientRect().bottom < 80);
      visibilityTicking = false;
    }
    function requestVisibilityUpdate() {
      if (visibilityTicking) return;
      visibilityTicking = true;
      window.requestAnimationFrame(updateVisibility);
    }
    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate, { passive: true });
    updateVisibility();
    update();
  }

  function initMobileMenu() {
    var header = document.querySelector('[data-inbody-site-header]');
    if (!header || header.dataset.menuInitialized === 'true') return;
    header.dataset.menuInitialized = 'true';
    var button = header.querySelector('[data-inbody-menu-toggle]');
    var panel = header.querySelector('[data-inbody-mobile-menu]');
    if (!button || !panel) return;
    button.addEventListener('click', function () {
      var open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
      header.classList.toggle('is-menu-open', !open);
    });
  }

  function initGlobe() {
    var globe = document.querySelector('[data-inbody-globe]');
    if (!globe || globe.dataset.initialized === 'true') return;
    globe.dataset.initialized = 'true';
    var close = globe.querySelector('[data-inbody-globe-close]');
    var choices = Array.prototype.slice.call(globe.querySelectorAll('.inbody-site-header__choice'));
    if (close) close.addEventListener('click', function () { globe.open = false; });
    choices.forEach(function (choice) {
      choice.addEventListener('toggle', function () {
        if (!choice.open) return;
        choices.forEach(function (other) { if (other !== choice) other.open = false; });
      });
    });
    document.addEventListener('click', function (event) {
      if (globe.open && !globe.contains(event.target)) globe.open = false;
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') globe.open = false;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncements(document);
    initAnnouncementOffset();
    initMobileMenu();
    initGlobe();
    initStickyCart();
  });
  document.addEventListener('shopify:section:load', function (event) {
    initAnnouncements(event.target);
    initAnnouncementOffset();
    initMobileMenu();
    initGlobe();
  });
})();
